import { LocalStorageKeys } from '@authentication/constants';
import Candidate from '@models/Candidate';
import axiosClient from '@services/api';
import EndPoints from '@services/endpoints';
import { AxiosResponse } from 'axios';

export const getCandidatesByPhone = async (
  phone: string,
): Promise<AxiosResponse<Candidate[] | []>> => {
  const formatPhoneNumber = phone.replaceAll(' ', '');
  const storeId = localStorage.getItem(LocalStorageKeys.STORE_ID);
  if (storeId) {
    return await axiosClient.get(
      `${EndPoints.Candidate.getCandidateByPhone(
        formatPhoneNumber,
        Number(storeId),
      )}`,
    );
  } else {
    throw Error('Something went wrong !');
  }
};
